// src/playback-runtime/arbitration/usePlaybackArbitration.ts

"use client";

import { useEffect, useRef } from "react";
import { playbackBus } from "../playbackBus";

/*
 Each player registers here.
 If another player starts -> this one pauses.
*/

export function usePlaybackArbitration(
  mediaRef: React.RefObject<HTMLMediaElement | null>
) {
  const idRef = useRef<string>(crypto.randomUUID());

  useEffect(() => {
    const el = mediaRef.current;
    if (!el) return;

    /* when this player starts -> claim ownership */
    const onPlay = () => {
      playbackBus.request(idRef.current);
    };

    /* when paused -> release */
    const onPause = () => {
      playbackBus.release(idRef.current);
    };

    el.addEventListener("play", onPlay);
    el.addEventListener("pause", onPause);

    /* react to other players */
    const unsubscribe = playbackBus.subscribe((activeId) => {
      if (!el) return;
      if (activeId !== idRef.current && !el.paused) {
        el.pause();
      }
    });

    return () => {
      el.removeEventListener("play", onPlay);
      el.removeEventListener("pause", onPause);
      unsubscribe();
      playbackBus.release(idRef.current);
    };
  }, [mediaRef]);
}
